enum TransactionUserAction {
  None = 0,
  Cancelled = 1,
  Abandoned = 2,
}

export { TransactionUserAction };
